export const COMPANY_DOMAIN = "logiqsystems.com"
export const COMPANY_NAME = "Logiq Systems"
export const COMPANY_URL = `https://${COMPANY_DOMAIN}/`

export const EMAILS = {
  support: `support@${COMPANY_DOMAIN}`,
  platform: `platform@${COMPANY_DOMAIN}`,
} as const
